import { formatIntDate } from "../../utils/utils";
export class OrderGetDto {
  constructor(order) {
    this.id = order.id;
    this.ordenCompra = order.cabecera.OrdenCompra || '';
    this.solicitante = order.cabecera.Solicitante || '';
    this.fechaPedido = order.cabecera.FechaPedido
      ? formatIntDate(order.cabecera.FechaPedido.toString())
      : '';
    this.fechaPromesa =
      order.productos && order.productos.length > 0
        ? formatIntDate(order.productos[0].FechaPromesa.toString())
        : order.cabecera.FechaPedido
        ? formatIntDate(order.cabecera.FechaPedido.toString())
        : '';
    this.cedula = order.cabecera.Cedula || '';
    this.nombre = order.cabecera.Nombre
      ? order.cabecera.Nombre.toUpperCase()
      : '';
    this.telefono = order.cabecera.Telefono || '';
    this.telefonoSecundario = order.cabecera.TelefonoSecundario || '';
    this.direccion = order.cabecera.Direccion || '';
    this.puntoVenta = order.cabecera.PuntoVenta || '';
    this.nombreCliente = order.cabecera.NombreCliente
      ? order.cabecera.NombreCliente.split("-")[1]
      : '';
    this.municipio = order.cabecera.Municipio || '';
    this.barrio = order.cabecera.Barrio || '';
    this.centro = order.cabecera.Centro || '';
    this.observaciones = order.cabecera.Observaciones || '';
    this.estado = order.cabecera.Estado
      ? order.cabecera.Estado.toUpperCase()
      : '';
    this.alertaLogistica = order.cabecera.AlertaLogistica || '';
    this.mensaje = order.cabecera.Mensaje || '';
    this.productos = order.productos
      ? order.productos?.map((producto) => new ProducGetDto(order.id, producto))
      : [];
  }
}

export class ProducGetDto {
  constructor(orderId, producto) {
    this.orderId = orderId;
    this.codigoMaterial = producto.CodigoMaterial || '';
    this.material = producto.Material || '';
    this.cantidad = producto.Cantidad || '';
    this.fechaEntrega = producto.FechaEntrega || '';
    this.fechaPromesa = producto.FechaPromesa || '';
    this.costo = producto.Costo || '';
    this.tirilla = producto.Tirilla || '';
    this.referencia = producto.Referencia || '';
    this.estado = producto.Estado || '';
    this.posicion = producto.Posicion || '';
  }
}